module.exports = __webpack_public_path__ + "img/Insureance1.ec660e7f.svg";